<template>
  <v-app >
    <v-navigation-drawer
      v-model="drawer"
      temporary
      right
      clipped
      enable-resize-watcher
      app
    >
      <v-toolbar
        flat
        class="transparent">
        <v-list class="pa-0">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>Men&uuml;</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>

      <v-divider/>

      <v-list>
        <v-list-tile
          v-for="(item, i) in navigationItems"
          :key="i"
          @click="goToRoute(item.uri)"
        >
          <v-list-tile-action>
            <v-icon
              class="blue-grey--text text--darken-3"
              v-html="item.icon"
            />
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title
              class="blue-grey--text text--darken-4"
              v-text="item.title"/>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      color="primary"
      app
    >
      <v-spacer/>
      <v-toolbar-side-icon
        class="white--text"
        @click.stop="drawer = !drawer"
      />
    </v-toolbar>
    <v-content>
      <v-container grid-list-sm>
        <v-layout
          row
          wrap>
          <v-flex
            xs12
            sm10
            md8
            lg6
            offset-sm1
            offset-md2
            offset-lg3
          >
            <router-view/>

          </v-flex>

        </v-layout>
      </v-container>
    </v-content>
    <elil-footer/>
  </v-app>
</template>

<script>
import ElilFooter from './components/ElilFooter';

export default {
  name: 'App',
  components: {
    ElilFooter,
  },
  data() {
    return {
      drawer: false,
      navigationItems: [
        {
          icon: 'home',
          title: 'Da Löwe',
          uri: '/',
        },
        {
          icon: 'view_list',
          title: 'Aktuelle Tabelle',
          uri: '/tabelle',
        },
        {
          icon: 'favorite',
          title: '#ELIL',
          uri: '/immer-loewe',
        }],
    };
  },
  mounted() {
    this.$store.dispatch('fetchTableData');
    this.$store.dispatch('fetchLatestMatch');
  },
  methods: {
    goToRoute(location) {
      this.$router.push(location);
    },
  },
};
</script>

<style lang="scss">
  .application.theme--light {
    background: #0D47A1; //hsla(216, 85%, 34%, 1)
    color: rgba(255,255,255,.87);

    background: linear-gradient(45deg, hsla(203, 73%, 40%, 1) 0%, hsla(203, 73%, 40%, 0) 70%),
    linear-gradient(135deg, hsla(230, 87%, 31%, 1) 10%, hsla(230, 87%, 31%, 0) 80%),
    linear-gradient(225deg, hsla(199, 78%, 43%, 1) 10%, hsla(199, 78%, 43%, 0) 80%),
    linear-gradient(315deg, hsla(239, 85%, 34%, 1) 100%, hsla(239, 85%, 34%, 0) 70%);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue